import { TimekeeperService } from "services/TimekeeperService";

const tk = new TimekeeperService()

const gettingInterpretationRule = async (setLoading, setRows) => {
    setLoading(true);

    tk.interpretation_rules.getAll()
        .then((response) => {
            const rows = response.map((interpretationpunch) => (
                {
                    id: interpretationpunch.interpretation_rule_id,
                    name: interpretationpunch.name,
                    punch_restriction: interpretationpunch.punch_restriction,
                    allow_substitution: interpretationpunch.allow_substitution,
                    enable: interpretationpunch.enable
                }
            ))
            setRows(rows);
        })
        .catch((error) => {
            console.error(error.message);
        })
        .finally(() => {
            setLoading(false);
        });
}

const createInterpretationRule = async (setLoading, data) => {
    setLoading(true);
    //console.log(data)
    return await tk.interpretation_rules.create(data)
}

const editInterpretationRule = async (setLoading, id, data) => {
    setLoading(true);
    return await tk.interpretation_rules.update(id, data)
}

const deleteInterpretationRule = async (setLoading, ids) => {
    setLoading(true);
    return await tk.interpretation_rules.delete(ids);
}

const gettingInterpretationRuleById = async (setLoading, id) => {
    setLoading(true);
    return await tk.interpretation_rules.get(id);
}


export {
    gettingInterpretationRule,
    createInterpretationRule,
    editInterpretationRule,
    deleteInterpretationRule,
    gettingInterpretationRuleById
}